function clearTimezoneFilter() {
    'ngInject';

    return function (val, offset) {
        if ((val !== null) && (val.length > 19)) {
            return val.substring(0, 19);
        }
        return val;
    };
}

angular
    .module('BB')
    .filter('clearTimezone', clearTimezoneFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/clear_timezone.filter.js